export default __webpack_public_path__ + "34d01b29b8e6cdadc1f6823fc3578a14.svg";